module.exports = __webpack_public_path__ + "static/media/european-union.1781e5f7.jpg";